import useUser from '@/utils/hooks/swr/useUser';
import dayjs from 'dayjs';

const useFormatTimeIndicator = () => {
    const { user } = useUser({
        revalidateOnMount: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false
    });

    const formatWeekDays = () => {
        // Create a copy of the array to avoid modifying the original array in read-only mode
        let weekDays = [...days];

        const firstDayOfTheWeek = user?.settings?.first_day_week;

        if (firstDayOfTheWeek !== 'monday') {
            const dayIndex = weekDays.findIndex((day) => day === firstDayOfTheWeek);
            if (dayIndex !== -1) {
                // Remove the found day and put it in first position
                const [removedDay] = weekDays.splice(dayIndex, 1);
                weekDays.unshift(removedDay);
            }
        }

        return weekDays;
    };

    const formatHours = () => {
        const dayHours = hours;
        let finalDayHours = [];

        dayHours.forEach((hour) => {
            finalDayHours.push(formatHour(hour));
        });

        return finalDayHours;
    };

    const formatHour = (hour) => {
        let timeFormat = user?.settings?.time_format;

        if (timeFormat === '12') {
            return dayjs(`2021-01-01 ${hour}`).format('ha');
        } else {
            return hour.replace(':', 'h');
        }
    };

    return { formatWeekDays, formatHours, formatHour };
};

const days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

const hours = [
    '00:00',
    '01:00',
    '02:00',
    '03:00',
    '04:00',
    '05:00',
    '06:00',
    '07:00',
    '08:00',
    '09:00',
    '10:00',
    '11:00',
    '12:00',
    '13:00',
    '14:00',
    '15:00',
    '16:00',
    '17:00',
    '18:00',
    '19:00',
    '20:00',
    '21:00',
    '22:00',
    '23:00'
];

export { useFormatTimeIndicator, hours, days };
